// @flow

import { type ConfirmedIncomingPayment, type CanceledIncomingPayment, type PendingIncomingPayment } from './types';

export function getWaitBeforeRedirect(incomingPayment: ConfirmedIncomingPayment|CanceledIncomingPayment|PendingIncomingPayment): ?number {
  return incomingPayment['wait_before_redirect'];
}
